"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const updateLanguagePath = lang => {
  const loc = window.location;
  const parts = loc.pathname.split("/");
  const restOfUrl = parts.slice(2).join("/");
  loc.assign(`${loc.origin}/${lang}/${restOfUrl}${loc.search}`);
};
var _default = exports.default = updateLanguagePath;